// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-5a94b919] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart * {
  box-sizing: border-box;
  line-height: 1.15;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  font-size: 16px;
  /* display: inline-block; */
  display: flex;
  flex-direction: column;
  height: 420px;
  color: #222427;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji {
  padding: 6px;
  position: relative;
  display: inline-block;
  font-size: 0;
  border: none;
  background: none;
  box-shadow: none;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji span {
  display: inline-block;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji .emoji-mart-emoji span {
  width: 38px;
  height: 38px;
  font-size: 32px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-native {
  font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji";
  word-break: keep-all;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image {
  /* Emoji sheet has 56 columns, see also utils/emoji-data.js, SHEET_COLUMNS variable */
  /* Here we use (56+1) * 100% to avoid visible edges of nearby icons when scaling for different
   * screen sizes */
  background-size: 6100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-apple {
  background-image: url("https://unpkg.com/emoji-datasource-apple@15.0.1/img/apple/sheets-256/64.png");
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-facebook {
  background-image: url("https://unpkg.com/emoji-datasource-facebook@15.0.1/img/facebook/sheets-256/64.png");
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-google {
  background-image: url("https://unpkg.com/emoji-datasource-google@15.0.1/img/google/sheets-256/64.png");
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-twitter {
  background-image: url("https://unpkg.com/emoji-datasource-twitter@15.0.1/img/twitter/sheets-256/64.png");
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar {
  border: 0 solid #d9d9d9;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar:first-child {
  border-bottom-width: 1px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar:last-child {
  border-top-width: 1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-scroll {
  position: relative;
  overflow-y: scroll;
  flex: 1;
  padding: 0 6px 6px 6px;
  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */
  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */
  -webkit-overflow-scrolling: touch;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 6px;
  color: #858585;
  line-height: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor {
  position: relative;
  display: block;
  flex: 1 1 auto;
  text-align: center;
  padding: 12px 4px;
  overflow: hidden;
  transition: color 0.1s ease-out;
  border: none;
  background: none;
  box-shadow: none;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor:hover,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-selected {
  color: #464646;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-selected .emoji-mart-anchor-bar {
  bottom: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-bar {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #464646;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors i {
  display: inline-block;
  width: 100%;
  max-width: 22px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors svg {
  fill: currentColor;
  max-height: 18px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .scroller {
  height: 250px;
  position: relative;
  flex: 1;
  padding: 0 6px 6px 6px;
  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */
  will-change: transform; /* avoids "repaints on scroll" in mobile Chrome */
  -webkit-overflow-scrolling: touch;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search {
  margin-top: 6px;
  padding: 0 6px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search input {
  font-size: 16px;
  display: block;
  width: 100%;
  padding: 0.2em 0.6em;
  border-radius: 25px;
  border: 1px solid #d9d9d9;
  outline: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search-results {
  height: 250px;
  overflow-y: scroll;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category {
  position: relative;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji span {
  z-index: 1;
  position: relative;
  text-align: center;
  cursor: default;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji:hover:before,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji-selected:before {
  z-index: 0;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  border-radius: 100%;
  opacity: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji:hover:before,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji-selected:before {
  opacity: 1;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category-label {
  position: sticky;
  top: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-static .emoji-mart-category-label {
  z-index: 2;
  position: relative;
  /* position: sticky; */
  /* position: -webkit-sticky; */
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category-label h3 {
  display: block;
  font-size: 16px;
  width: 100%;
  font-weight: 500;
  padding: 5px 6px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.95);
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji {
  position: relative;
  display: inline-block;
  font-size: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results {
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  color: #858585;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-category-label {
  display: none;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-no-results-label {
  margin-top: 0.2em;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-emoji:hover:before {
  content: none;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview {
  position: relative;
  height: 70px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-data,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-skins {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji {
  left: 12px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-data {
  left: 68px;
  right: 12px;
  word-break: break-all;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-skins {
  right: 30px;
  text-align: right;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-name {
  font-size: 14px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname {
  font-size: 12px;
  color: #888;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname + .emoji-mart-preview-shortname,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {
  margin-left: 0.5em;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoticon {
  font-size: 11px;
  color: #bbb;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title span {
  display: inline-block;
  vertical-align: middle;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title .emoji-mart-emoji {
  padding: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title-label {
  color: #999a9c;
  font-size: 21px;
  font-weight: 300;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches {
  font-size: 0;
  padding: 2px 0;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background-color: #fff;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch {
  width: 16px;
  padding: 0 2px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected:after {
  opacity: 0.75;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch {
  display: inline-block;
  width: 0;
  vertical-align: middle;
  transition-property: width, padding;
  transition-duration: 0.125s;
  transition-timing-function: ease-out;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(1) {
  transition-delay: 0s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(2) {
  transition-delay: 0.03s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(3) {
  transition-delay: 0.06s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(4) {
  transition-delay: 0.09s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(5) {
  transition-delay: 0.12s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(6) {
  transition-delay: 0.15s;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch-selected {
  position: relative;
  width: 16px;
  padding: 0 2px;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch-selected:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin: -2px 0 0 -2px;
  background-color: #fff;
  border-radius: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin {
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  max-width: 12px;
  border-radius: 100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-1 {
  background-color: #ffc93a;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-2 {
  background-color: #fadcbc;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-3 {
  background-color: #e0bb95;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-4 {
  background-color: #bf8f68;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-5 {
  background-color: #9b643d;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-6 {
  background-color: #594539;
}
.nc-emoji-picker-container[data-v-5a94b919]  {
  /* vue-virtual-scroller/dist/vue-virtual-scroller.css */
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller {
  position: relative;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-vertical:not(.page-mode) {
  overflow-y: auto;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal:not(.page-mode) {
  overflow-x: auto;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal {
  display: flex;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller__slot {
  flex: auto 0 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller__item-wrapper {
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready .vue-recycle-scroller__item-view {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper {
  width: 100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper {
  height: 100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view {
  width: 100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view {
  height: 100%;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .resize-observer[data-v-b329ee4c] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .resize-observer[data-v-b329ee4c] object {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}
.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search .hidden {
  display: none;
  visibility: hidden;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {
  background-color: var(--color-main-background) !important;
  border: 0;
  color: var(--color-main-text) !important;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart button {
  border: none;
  background: transparent;
  font-size: inherit;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-bar,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchors,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-search,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-search input,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category-label,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category-label span,
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-skin-swatches {
  background-color: transparent !important;
  border-color: var(--color-border) !important;
  color: inherit !important;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchors {
  padding-block: 0;
  padding-inline: calc(2 * var(--default-grid-baseline));
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor {
  border-radius: 0;
  margin: 0 !important;
  padding: 0 !important;
  height: var(--clickable-area-small);
  min-width: var(--clickable-area-small);
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor:hover {
  background-color: var(--color-background-hover);
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor:focus-visible {
  outline: 2px solid var(--color-primary-element) !important;
  outline-offset: -2px;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor div {
  display: grid;
  place-content: center;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-scroll {
  padding-inline: calc(2 * var(--default-grid-baseline));
  padding-block: 0 calc(2 * var(--default-grid-baseline));
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  justify-items: stretch;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category.emoji-mart-no-results {
  grid-template-columns: 1fr;
  font-size: inherit;
  color: var(--color-text-maxcontrast) !important;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {
  /* Label element in the section grid */
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart div.emoji-mart-category-label {
  grid-column: span 8;
  justify-self: stretch;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {
  /* An actual heading inside the element */
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart h3.emoji-mart-category-label {
  display: flex;
  align-items: center;
  height: var(--default-clickable-area);
  margin: 0;
  padding-inline: calc(2 * var(--default-grid-baseline));
  padding-block: 0;
  user-select: none;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji {
  aspect-ratio: 1/1;
  text-align: center;
  margin: 0 !important;
  padding: 0 !important;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji:hover, .nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji:focus-visible, .nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji.emoji-mart-emoji-selected {
  background-color: var(--color-background-hover) !important;
  border: none;
  border-radius: var(--border-radius-element, var(--border-radius-pill));
  box-shadow: none !important;
  outline: 2px solid var(--color-primary-element) !important;
  outline-offset: -2px;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji::before {
  display: none;
}
.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji span {
  cursor: pointer;
}
.search__wrapper[data-v-5a94b919] {
  display: flex;
  flex-direction: row;
  gap: var(--default-grid-baseline);
  align-items: end;
  padding-block: var(--default-grid-baseline);
  padding-inline: calc(2 * var(--default-grid-baseline));
}
.row-selected button[data-v-5a94b919], .row-selected span[data-v-5a94b919] {
  vertical-align: middle;
}
.emoji-delete[data-v-5a94b919] {
  vertical-align: top;
  margin-left: -21px;
  margin-top: -3px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcEmojiPicker-CrjOSMLF.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,4EAA4E;EAC5E,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,2JAA2J;EAC3J,oBAAoB;AACtB;AACA;EACE,qFAAqF;EACrF;mBACiB;EACjB,sBAAsB;AACxB;AACA;EACE,oGAAoG;AACtG;AACA;EACE,0GAA0G;AAC5G;AACA;EACE,sGAAsG;AACxG;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,UAAU,EAAE,kEAAkE;EAC9E,sBAAsB,EAAE,iDAAiD;EACzE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,UAAU,EAAE,kEAAkE;EAC9E,sBAAsB,EAAE,iDAAiD;EACzE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yDAAyD;EACzD,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;;;;;;;EAQE,wCAAwC;EACxC,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,0DAA0D;EAC1D,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,sDAAsD;EACtD,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,0DAA0D;EAC1D,YAAY;EACZ,sEAAsE;EACtE,2BAA2B;EAC3B,0DAA0D;EAC1D,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,2CAA2C;EAC3C,sDAAsD;AACxD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-5a94b919] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  /* display: inline-block; */\n  display: flex;\n  flex-direction: column;\n  height: 420px;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji {\n  padding: 6px;\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji span {\n  display: inline-block;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji .emoji-mart-emoji span {\n  width: 38px;\n  height: 38px;\n  font-size: 32px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-native {\n  font-family: \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Segoe UI\", \"Apple Color Emoji\", \"Twemoji Mozilla\", \"Noto Color Emoji\", \"EmojiOne Color\", \"Android Emoji\";\n  word-break: keep-all;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image {\n  /* Emoji sheet has 56 columns, see also utils/emoji-data.js, SHEET_COLUMNS variable */\n  /* Here we use (56+1) * 100% to avoid visible edges of nearby icons when scaling for different\n   * screen sizes */\n  background-size: 6100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-apple {\n  background-image: url(\"https://unpkg.com/emoji-datasource-apple@15.0.1/img/apple/sheets-256/64.png\");\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-facebook {\n  background-image: url(\"https://unpkg.com/emoji-datasource-facebook@15.0.1/img/facebook/sheets-256/64.png\");\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-google {\n  background-image: url(\"https://unpkg.com/emoji-datasource-google@15.0.1/img/google/sheets-256/64.png\");\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-type-image.emoji-set-twitter {\n  background-image: url(\"https://unpkg.com/emoji-datasource-twitter@15.0.1/img/twitter/sheets-256/64.png\");\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-scroll {\n  position: relative;\n  overflow-y: scroll;\n  flex: 1;\n  padding: 0 6px 6px 6px;\n  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */\n  will-change: transform; /* avoids \"repaints on scroll\" in mobile Chrome */\n  -webkit-overflow-scrolling: touch;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  color: #858585;\n  line-height: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor:hover,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-selected {\n  color: #464646;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #464646;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-anchors svg {\n  fill: currentColor;\n  max-height: 18px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .scroller {\n  height: 250px;\n  position: relative;\n  flex: 1;\n  padding: 0 6px 6px 6px;\n  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */\n  will-change: transform; /* avoids \"repaints on scroll\" in mobile Chrome */\n  -webkit-overflow-scrolling: touch;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 0.2em 0.6em;\n  border-radius: 25px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search-results {\n  height: 250px;\n  overflow-y: scroll;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category {\n  position: relative;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji:hover:before,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji-selected:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n  opacity: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category .emoji-mart-emoji:hover:before,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji-selected:before {\n  opacity: 1;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category-label {\n  position: sticky;\n  top: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-static .emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  /* position: sticky; */\n  /* position: -webkit-sticky; */\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-category-label h3 {\n  display: block;\n  font-size: 16px;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.95);\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: 0.2em;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-data,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoji {\n  left: 12px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-data {\n  left: 68px;\n  right: 12px;\n  word-break: break-all;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-name {\n  font-size: 14px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: 0.5em;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-title-label {\n  color: #999a9c;\n  font-size: 21px;\n  font-weight: 300;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected:after {\n  opacity: 0.75;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(1) {\n  transition-delay: 0s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(2) {\n  transition-delay: 0.03s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(3) {\n  transition-delay: 0.06s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(4) {\n  transition-delay: 0.09s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(5) {\n  transition-delay: 0.12s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch:nth-child(6) {\n  transition-delay: 0.15s;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch-selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-swatch-selected:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-1 {\n  background-color: #ffc93a;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-2 {\n  background-color: #fadcbc;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-3 {\n  background-color: #e0bb95;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-4 {\n  background-color: #bf8f68;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-5 {\n  background-color: #9b643d;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-skin-tone-6 {\n  background-color: #594539;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  {\n  /* vue-virtual-scroller/dist/vue-virtual-scroller.css */\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller {\n  position: relative;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-vertical:not(.page-mode) {\n  overflow-y: auto;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal:not(.page-mode) {\n  overflow-x: auto;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal {\n  display: flex;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller__slot {\n  flex: auto 0 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller__item-wrapper {\n  flex: 1;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready .vue-recycle-scroller__item-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  will-change: transform;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper {\n  width: 100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper {\n  height: 100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view {\n  width: 100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view {\n  height: 100%;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .resize-observer[data-v-b329ee4c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  pointer-events: none;\n  display: block;\n  overflow: hidden;\n  opacity: 0;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart .resize-observer[data-v-b329ee4c] object {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n.nc-emoji-picker-container[data-v-5a94b919]  .emoji-mart-search .hidden {\n  display: none;\n  visibility: hidden;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {\n  background-color: var(--color-main-background) !important;\n  border: 0;\n  color: var(--color-main-text) !important;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart button {\n  border: none;\n  background: transparent;\n  font-size: inherit;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-bar,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchors,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-search,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-search input,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category-label,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category-label span,\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-skin-swatches {\n  background-color: transparent !important;\n  border-color: var(--color-border) !important;\n  color: inherit !important;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchors {\n  padding-block: 0;\n  padding-inline: calc(2 * var(--default-grid-baseline));\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor {\n  border-radius: 0;\n  margin: 0 !important;\n  padding: 0 !important;\n  height: var(--clickable-area-small);\n  min-width: var(--clickable-area-small);\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor:hover {\n  background-color: var(--color-background-hover);\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor:focus-visible {\n  outline: 2px solid var(--color-primary-element) !important;\n  outline-offset: -2px;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-anchor div {\n  display: grid;\n  place-content: center;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-scroll {\n  padding-inline: calc(2 * var(--default-grid-baseline));\n  padding-block: 0 calc(2 * var(--default-grid-baseline));\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  justify-items: stretch;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-category.emoji-mart-no-results {\n  grid-template-columns: 1fr;\n  font-size: inherit;\n  color: var(--color-text-maxcontrast) !important;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {\n  /* Label element in the section grid */\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart div.emoji-mart-category-label {\n  grid-column: span 8;\n  justify-self: stretch;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart {\n  /* An actual heading inside the element */\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart h3.emoji-mart-category-label {\n  display: flex;\n  align-items: center;\n  height: var(--default-clickable-area);\n  margin: 0;\n  padding-inline: calc(2 * var(--default-grid-baseline));\n  padding-block: 0;\n  user-select: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji {\n  aspect-ratio: 1/1;\n  text-align: center;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji:hover, .nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji:focus-visible, .nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji.emoji-mart-emoji-selected {\n  background-color: var(--color-background-hover) !important;\n  border: none;\n  border-radius: var(--border-radius-element, var(--border-radius-pill));\n  box-shadow: none !important;\n  outline: 2px solid var(--color-primary-element) !important;\n  outline-offset: -2px;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji::before {\n  display: none;\n}\n.nc-emoji-picker-container[data-v-5a94b919] .emoji-mart .emoji-mart-emoji span {\n  cursor: pointer;\n}\n.search__wrapper[data-v-5a94b919] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--default-grid-baseline);\n  align-items: end;\n  padding-block: var(--default-grid-baseline);\n  padding-inline: calc(2 * var(--default-grid-baseline));\n}\n.row-selected button[data-v-5a94b919], .row-selected span[data-v-5a94b919] {\n  vertical-align: middle;\n}\n.emoji-delete[data-v-5a94b919] {\n  vertical-align: top;\n  margin-left: -21px;\n  margin-top: -3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
